import 'lazysizes';
import './browser-update';
import './routes/search-banner';
import './routes/mobile-menu';
import './libs/consent'

if(document.querySelector('.header.header .swiper')) {
    import('./routes/header-swiper.js');
}

if(document.querySelector('.related--container .swiper')) {
    import('./routes/related-swiper.js')
}

if(document.querySelector('.audio-swiper .swiper')){
    import('./components/audio-swiper')
}

if(document.querySelector('.article-sidebar-nav')) {
    import('./routes/floating-sidebar.js');
}

if(window.location.pathname == "/videos/" && document.querySelector('.swiper')) {
    import('./routes/videos.js')
}

if(document.querySelector('video')) {
    import('./routes/inline-video.js');
}

if(document.querySelector('.doc-viewer-close')) {
    import('./routes/doc-viewer.js');
}

if(document.querySelector('.the-grid')) {
    import('./routes/thegrid.js');
}

if(document.querySelector('.audio-player')) {
    import('./routes/audio.js');
}

if (document.querySelector('whois-search')) {
    import('./components/search.js')
}

if (document.querySelector('whois-captcha-form')) {
    import('./components/captcha-form.js')
}

if (document.querySelector('whois-clamp-box')) {
    import('./components/clamp-box.js')
}

if (document.querySelector('.audio-player,.audio-player-simple') != null) {
    import('./routes/audio.js')
}